// extracted by mini-css-extract-plugin
var _1 = "X3DKd";
var _2 = "qc2Yo";
var _3 = "Pc75z";
var _4 = "efnIX";
export { _1 as "base", _2 as "paused", _3 as "theme-dark", _4 as "theme-light" }
